/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} North_Helpful_Wolf_EmbraceInputs */

const en_north_helpful_wolf_embrace = /** @type {(inputs: North_Helpful_Wolf_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const de_north_helpful_wolf_embrace = /** @type {(inputs: North_Helpful_Wolf_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkel`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {North_Helpful_Wolf_EmbraceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const north_helpful_wolf_embrace = /** @type {((inputs?: North_Helpful_Wolf_EmbraceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<North_Helpful_Wolf_EmbraceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_north_helpful_wolf_embrace(inputs)
	return de_north_helpful_wolf_embrace(inputs)
});